var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google_Calendar_icon_(2020)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toxicology",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toxicological-appointment-confirmation",
    transform: "translate(-772.000000, -934.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-2",
    transform: "translate(735.000000, 797.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_Calendar_icon_(2020)",
    transform: "translate(37.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "18.3157895 5.68421053 5.68421053 5.68421053 5.68421053 18.3157895 18.3157895 18.3157895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA4335",
    points: "18.3157895 24 24 18.3157895 18.3157895 18.3157895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FBBC04",
    points: "24 5.68421053 18.3157895 5.68421053 18.3157895 18.3157895 24 18.3157895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#34A853",
    points: "18.3157895 18.3157895 5.68421053 18.3157895 5.68421053 24 18.3157895 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.3157895 L0,22.1052632 C0,23.1521053 0.847894737,24 1.89473684,24 L5.68421053,24 L5.68421053,18.3157895 L0,18.3157895 Z",
    id: "Path",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,5.68421053 L24,1.89473684 C24,0.847894737 23.1521053,0 22.1052632,0 L18.3157895,0 L18.3157895,5.68421053 L24,5.68421053 Z",
    id: "Path",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3157895,0 L1.89473684,0 C0.847894737,0 0,0.847894737 0,1.89473684 L0,18.3157895 L5.68421053,18.3157895 L5.68421053,5.68421053 L18.3157895,5.68421053 L18.3157895,0 Z",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27526316,15.4831579 C7.80315789,15.1642105 7.47631579,14.6984211 7.29789474,14.0826316 L8.39368421,13.6310526 C8.49315789,14.01 8.66684211,14.3036842 8.91473684,14.5121053 C9.16105263,14.7205263 9.46105263,14.8231579 9.81157895,14.8231579 C10.17,14.8231579 10.4778947,14.7142105 10.7352632,14.4963158 C10.9926316,14.2784211 11.1221053,14.0005263 11.1221053,13.6642105 C11.1221053,13.32 10.9863158,13.0389474 10.7147368,12.8210526 C10.4431579,12.6031579 10.1021053,12.4942105 9.69473684,12.4942105 L9.06157895,12.4942105 L9.06157895,11.4094737 L9.63,11.4094737 C9.98052632,11.4094737 10.2757895,11.3147368 10.5157895,11.1252632 C10.7557895,10.9357895 10.8757895,10.6768421 10.8757895,10.3468421 C10.8757895,10.0531579 10.7684211,9.81947368 10.5536842,9.64421053 C10.3389474,9.46894737 10.0673684,9.38052632 9.73736842,9.38052632 C9.41526316,9.38052632 9.15947368,9.46578947 8.97,9.63789474 C8.78065143,9.81045797 8.6382957,10.0283383 8.55631579,10.2710526 L7.47157895,9.81947368 C7.61526316,9.41210526 7.87894737,9.05210526 8.26578947,8.74105263 C8.65263158,8.43 9.14684211,8.27368421 9.74684211,8.27368421 C10.1905263,8.27368421 10.59,8.35894737 10.9436842,8.53105263 C11.2973684,8.70315789 11.5752632,8.94157895 11.7757895,9.24473684 C11.9763158,9.54947368 12.0757895,9.89052632 12.0757895,10.2694737 C12.0757895,10.6563158 11.9826316,10.9831579 11.7963158,11.2515789 C11.61,11.52 11.3810526,11.7252632 11.1094737,11.8689474 L11.1094737,11.9336842 C11.460147,12.0782615 11.7647575,12.3157267 11.9905263,12.6205263 C12.2194737,12.9284211 12.3347368,13.2963158 12.3347368,13.7257895 C12.3347368,14.1552632 12.2257895,14.5389474 12.0078947,14.8752632 C11.79,15.2115789 11.4884211,15.4768421 11.1063158,15.6694737 C10.7226316,15.8621053 10.2915789,15.9600116 9.81315789,15.9600116 C9.25894737,15.9615789 8.74736842,15.8021053 8.27526316,15.4831579 L8.27526316,15.4831579 Z M15.0063158,10.0452632 L13.8031579,10.9152632 L13.2015789,10.0026316 L15.36,8.44578947 L16.1873684,8.44578947 L16.1873684,15.7894737 L15.0063158,15.7894737 L15.0063158,10.0452632 Z",
    id: "Shape",
    fill: "#4285F4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarIcon);
export default __webpack_public_path__ + "static/media/google_calendar_icon.454c42f7575e5930ffa3d180b370db0a.svg";
export { ForwardRef as ReactComponent };